import {
  mapToSalesOrganizationId,
  type SalesOrganizationId,
} from "@/shared/@types/SalesOrganizationId";
import { mapToWebStoreId, WebStoreId } from "@/shared/@types/WebStoreId";
import type { AccountEntityExpandResponse } from "@/shared/generated/ExpHubApi";

export type WebStore = {
  id: WebStoreId;
  salesOrganizationId: SalesOrganizationId | undefined;
  type: "default" | "global-gas";
};

export const mapToWebStore = (
  data: NonNullable<
    AccountEntityExpandResponse["account"]["webstores"]
  >[number],
): WebStore | undefined => {
  const webStoreId = mapToWebStoreId(data.webstoreExternalId);
  if (!webStoreId) {
    return undefined;
  }

  return {
    id: webStoreId,
    salesOrganizationId: mapToSalesOrganizationId(data.salesOrganizationId),
    type: webStoreId === WebStoreId.GG_DE ? "global-gas" : "default",
  };
};
